import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AlertMessage } from '../../../components/ui/AlertMessage/AlertMessage';
import { Helpers } from '../../../utils/helpers';
import styles from './LoginForm.module.css';
import logoImage from '../../../assets/images/logo-dark.png';
import useLoginForm from './useLoginForm';
import FragmentContainer from '../../../components/ui/FragmentContainer/FragmentContainer';
import { LoginView } from '../../../utils/constants/enums';

export const LoginForm = () => {
  const manager = useLoginForm();

  return (
    <div className="loginFormContainer">
      <div className="logoContainer">
        <img src={logoImage} alt="" />
      </div>
      <FragmentContainer visible={manager.loginView === LoginView.MFA}>
        <form onSubmit={(e) => manager.handleMfaSubmit(e)}>
          <div className={styles.mfaHeading}>
            <h2>Verify Your Identity</h2>
            We&apos;ve sent a verification code to your email. Enter the code below to proceed.
          </div>
          <AlertMessage
            visible={!Helpers.isNullOrWhiteSpace(manager.alertDetails.message)}
            status={manager.alertDetails.status}
            message={manager.alertDetails.message}
          />
          <div className="form-group">
            <input
              type="text"
              disabled={manager.loggingIn}
              className={`form-control ${styles.mfaCode}`}
              value={manager.mfaValidationRequest.mfaCode}
              autoFocus={true}
              maxLength={6}
              onChange={(e: React.FormEvent<HTMLInputElement>) =>
                manager.updateMfaRequest('mfaCode', e.currentTarget.value)
              }
            />
          </div>
          <div className="form-group">
            <div className={`form-check ${styles.rememberMe}`}>
              <input
                type="checkbox"
                id="mfaRememberMe"
                className="form-check-input"
                onChange={() => manager.toggleRememberMe()}
                checked={manager.mfaValidationRequest.rememberMe}
              />
              <label className="form-check-label" htmlFor="mfaRememberMe">
                Don&apos;t ask me again for 7 days.
              </label>
            </div>
          </div>
          <div className="d-grid gap-2 mt-3">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={manager.mfaValidationRequest.mfaCode.length < 6 || manager.loggingIn}>
              Verify{' '}
              {manager.loggingIn && <Spinner size="sm" animation="border" className="ms-2" />}
            </button>
          </div>
        </form>
      </FragmentContainer>
      <FragmentContainer visible={manager.loginView === LoginView.LOGIN}>
        <AlertMessage
          visible={!Helpers.isNullOrWhiteSpace(manager.alertDetails.message)}
          status={manager.alertDetails.status}
          message={manager.alertDetails.message}
        />
        <form onSubmit={(e) => manager.handleSubmit(e)}>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="text"
              disabled={manager.loggingIn}
              className="form-control"
              id="email"
              value={manager.loginRequest.userName}
              autoFocus={true}
              onChange={(e: React.FormEvent<HTMLInputElement>) =>
                manager.updateEmail(e.currentTarget.value)
              }
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              disabled={manager.loggingIn}
              className="form-control"
              id="password"
              value={manager.loginRequest.password}
              onChange={(e: React.FormEvent<HTMLInputElement>) =>
                manager.updatePassword(e.currentTarget.value)
              }
            />
          </div>
          <div className="d-grid gap-2 mt-3">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={
                Helpers.isNullOrWhiteSpace(manager.loginRequest.userName) ||
                Helpers.isNullOrWhiteSpace(manager.loginRequest.password) ||
                manager.loggingIn
              }>
              Log In{' '}
              {manager.loggingIn && <Spinner size="sm" animation="border" className="ms-2" />}
            </button>
          </div>
        </form>
        <div className="mt-2">
          <Link to="/forgot-password">Forgot Your Password?</Link>
        </div>
        <div className="app-version-login">{manager.appVersion}</div>
      </FragmentContainer>
    </div>
  );
};
